import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import {
    Grid, Card, Typography, FormHelperText, Button,
    TextField, FormControl, Box,
    Divider, FormControlLabel, Checkbox
} from "@mui/material";
import { Image } from 'mui-image'
import "../../static/css/login.css"
import LogoTransparent from "../../static/images/login/lynkitGrayLogo.png"
import Logo from "../../static/images/login/lynkGridGrayLogo.png"
import LockShackle from "../../static/images/login/Subtract.png"
import LockShackleError from "../../static/images/login/SubtractError.png"
import LockShackleSuccess from "../../static/images/login/SubtractLoggedIn.png"
import LockBodyBg from "../../static/images/login/lockBgColor.png"
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import theme, { inputClasses, cardClasses, textClasses, buttonClasses } from '../../static/styles/theme';
import { showToast } from "../../services/functions";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import GenericLoader from '../Components/Generic/GenericLoader';
import { valid_email, valid_otp_six_digit } from "../../services/validation"
import { forgotPasswordCase, verifyOTPCase, changePasswordCase, getCentralTheming } from '../../redux/actions';
import { encryptTheData } from '../../services/Api';
import { localStorageLogoutConditions } from '../../utils/services';
import { userLogin } from "../../redux/actions/Auth"
import TwoFactorAuth from './TwoFactorAuth';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import PinOutlinedIcon from '@mui/icons-material/PinOutlined';
export const allowedOrigins = [
    "warehouse.lynkgrid.com",
    "preprodwarehouse.lynkgrid.com",
    "warehouse-new.lynkgrid.com",
    "http://localhost",
    "localhost"
];

export function useTokenExpiry(token, setOtpToken, handleBackBtnClick) {
    useEffect(() => {
        if (!token) return; // if no token, exit early

        try {
            // Decode the JWT payload (the middle part of token)
            const payload = JSON?.parse(atob(token?.split(".")[1]));
            // Normally you'd get expiry time like this:
            const exp = payload.exp * 1000; // convert seconds to ms
            const now = Date.now();
            const remainingTime = exp - now;

            // But for testing, you hard-coded it:
            // const remainingTime = 5000; // 5 seconds

            if (remainingTime > 0) {
                // Token is still valid
                const timeout = setTimeout(() => {
                    // Once time is up → expire the token
                    showToast("Token expired, please generate again.", true);
                    setOtpToken("");       // reset token
                    handleBackBtnClick();  // reset step / go back
                }, remainingTime);

                // cleanup (clear timeout when component unmounts OR when token changes)
                return () => clearTimeout(timeout);

            } else {
                // ELSE: token already expired before you even set it
                setOtpToken("");             // reset token
                handleBackBtnClick();  // force redirect to login
            }
        } catch (err) {
            // If the token is invalid (bad format or corrupted)
            setOtpToken("");
            handleBackBtnClick();
        }
    }, [token]);
}


export function getHost(url) {
    const hostname = new URL(url).hostname;
    return allowedOrigins.includes(hostname) ? "warehouse" : hostname;
}
// export const originHost = getHost("https://veritaslogistics.lynkgrid.com/"); // for testing purpose

export const originHost = getHost(window.location.origin);
// https://whitelabling.s3.ap-south-1.amazonaws.com/demoz.tektronixit.com/themeColor
export const dynamicDomain = `https://whitelabling.s3.ap-south-1.amazonaws.com/${originHost}`
// console.log("themee", `${dynamicDomain}/themeSetting.json`)

const Login2 = (props) => {
    const dispatch = useDispatch();
    const { register, handleSubmit, formState: { errors }, getValues, reset, watch } = useForm();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [open2FaForm, setOpen2FaForm] = useState(null);
    const [otpToken, setOtpToken] = useState("")
    const [loader, setLoader] = useState('global');
    const [step, setStep] = useState(0);
    const [showLockShackError, setShowLockShackError] = useState(false)
    const [showLockShackSuccess, setShowLockShackSuccess] = useState(false)
    const passwordValue = watch(step === 2 ? "newPassword" : "password");
    const isSubmitting = loader === 'login';
    const getButtonLabel = () => {
        if (!isSubmitting) {
            return step === 0 ? "Sign In" : step === 1 ? "Send OTP" : "Verify OTP";
        }

        return step === 0
            ? "Signing In..."
            : step === 1
                ? "Sending OTP..."
                : "Verifying OTP...";
    };
    const getIconColor = (val) => (val ? theme.themeOrange : theme.themeLoginPageWhite);
    // const otpToken = parseJwt(loginResponse?.resendOtpToken)
    const handleBackBtnClick = () => {
        reset();
        setOpen2FaForm(null);
        setStep(0);
        setShowLockShackError(false);
    };
    useTokenExpiry(otpToken, setOtpToken, handleBackBtnClick);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);
    const handleMouseDownConfirmPassword = (event) => {
        event.preventDefault();
    };
    const handleLogin = (data) => {
        setShowLockShackError(false); // reset error
        setShowLockShackSuccess(false);
        setLoader('login');
        let encryptedData = { payloadData: encryptTheData(data) };
        dispatch(
            userLogin(encryptedData, (response, error) => {
                setLoader('');
                if (response && response.success) {
                    setShowLockShackSuccess(true);
                    // console.log('✅ Login Success:', response);
                    if (response?.twoFactorAuth === true) {
                        setOtpToken(response?.resendOtpToken)
                        setOpen2FaForm(response); // Trigger 2FA popup
                    }
                } else {
                    setShowLockShackError(true)
                    // console.log('Login Failed:', error);
                    showToast(error || 'Login failed', true);
                }
            })
        );
    };
    const handleResetLink = (data) => {
        setLoader('login');
        let encryptedData = { payloadData: encryptTheData(data) };
        dispatch(
            forgotPasswordCase(encryptedData, (response = {}) => {
                showToast(response.message, !response.success);
                setLoader('');
                if (response.success) {
                    reset();
                    setStep(2);
                }
            })
        );
    };
    const handleOTPVerification = (data) => {
        if (data?.confirmPassword !== data?.newPassword) {
            showToast('Password did not matched correctly', true);
            return;
        }
        setLoader('login');
        let encryptedData = { payloadData: encryptTheData(data) };
        dispatch(
            verifyOTPCase(encryptedData, (response = {}) => {
                showToast(response.message, !response.success);
                setLoader('');
                if (response.success) {
                    reset();
                    setStep(0);
                }
            })
        );
    };
    const onPressingEnterFunction = (e) => {
        let formData = getValues();
        const isEnterPressed = e.key === 'Enter';
        if (!isEnterPressed) return;
        const requiredFields = {
            0: ['email', 'password'],
            1: ['email'],
            2: ['email', 'otp', 'newPassword', 'confirmPassword'],
        };
        const isFormComplete = requiredFields[step]?.every((field) => formData?.[field]);
        if (!isFormComplete) {
            return;
        }
        const handlers = {
            0: handleLogin,
            1: handleResetLink,
            2: handleOTPVerification,
        };
        if (handlers[step]) {
            handleSubmit(handlers[step])();
        }
    };
    useEffect(() => {
        // Clear localStorage to prevent partial authentication
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        let expiryMessage = window.localStorage.getItem('TokenExpirymesssage');
        if (expiryMessage) {
            showToast(expiryMessage, true);
            localStorageLogoutConditions();
        }
        setTimeout(() => {
            setLoader('');
        }, 1000);
    }, []);
    useEffect(() => {
        fetch(`${dynamicDomain}/themeSetting.json`)
            .then((res) => {
                if (!res.ok) throw new Error('Fetch failed');
                return res.json();
            })
            .then((data) => {
                console.log('Theme color:', data);
            })
            .catch((err) => {
                console.error('Error fetching theme:', err);
            });
    }, []);
    useEffect(() => {
        if (!passwordValue && showPassword) {
            setShowPassword(false);
        }
    }, [passwordValue]);

    const getShackleStyle = () => {
        if (!showLockShackSuccess) {
            // 🔒 Default + Error → untouched
            return {
                width: "300px",
                height: "200px",
                objectFit: "contain",
                display: "block",
                marginBottom: "-5px",
                transition: "opacity 0.3s ease",
            };
        }

        // Success → bigger image + subtle slide
        return {
            width: "420px",          // match wrapper growth
            height: "200px",
            objectFit: "contain",
            display: "block",
            marginBottom: "-5px",
            transform: "translateX(182px)", // fine tune arc position
            opacity: 0.65,
            transition:
                "transform 0.45s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.6s ease",
        };
    };



    return (
        <>
            {loader === 'global' ? (
                <Grid
                    item={true}
                    data-testid="loader"
                    container
                    direction={'column'}
                    justifyContent={'center'}
                    alignItems="center"
                    xs={12}
                    sx={{ p: 5, height: '80vh' }}
                >
                    <Grid item>
                        <GenericLoader />
                    </Grid>
                </Grid>
            ) : (
                <Grid container>
                    <Grid
                        item
                        md={8}
                        sm={12}
                        xs={12}
                        className={originHost === 'warehouse' ? 'bg-image-login' : 'bg-new'}
                        sx={{
                            height: { md: '100vh', xs: '40vh', sm: '60vh' },
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'flex-start',
                            backgroundColor: theme.themeBlack,
                            // position: 'relative',
                        }}
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 24,
                                left: 30,
                                width: 142,
                                height: 90,
                                zIndex: 2,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <Image
                                data-testid="logo-company"
                                src={originHost === 'warehouse' ? LogoTransparent : `${dynamicDomain}/logo.png`}
                                alt="signin-logo"
                                width={142}
                                height={90}
                                style={{ objectFit: 'contain' }}
                            />
                        </Box>
                    </Grid>
                    <Grid
                        container
                        item
                        md={4}
                        sm={12}
                        xs={12}
                        justifyContent="center"
                        alignItems="center"
                        direction={'column'}
                    >
                        {!open2FaForm && (
                            <Grid
                                container
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                    // minHeight: "80vh",
                                    height: '100vh',
                                    background: theme.themeBlack, // full-page dark background
                                }}
                            >
                                {/* WRAP SHACKLE & BODY TOGETHER */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        // 🔥 Responsive scaling
                                        transform: {
                                            xs: "scale(0.85)",
                                            sm: "scale(0.9)",
                                            md: "scale(1)",
                                            lg: "scale(1)",
                                            xl: "scale(1.3)",
                                        },
                                        transformOrigin: "center",
                                    }}
                                >
                                    {/* 🔒 LOCK SHACKLE IMAGE */}
                                    {/* 🔒 LOCK SHACKLE WRAPPER (CLIPS OVERFLOW) */}
                                    {step === 0 && (
                                        <Box
                                            sx={{
                                                width: showLockShackSuccess ? "420px" : "300px", // 🔥 wider ONLY on success
                                                height: "200px",
                                                overflow: "hidden", // clip excess
                                                position: "relative",
                                                transition: "width 0.45s cubic-bezier(0.4, 0, 0.2, 1)", // smooth expand
                                            }}
                                        >
                                            <img
                                                src={
                                                    showLockShackError
                                                        ? LockShackleError
                                                        : showLockShackSuccess
                                                            ? LockShackleSuccess
                                                            : LockShackle
                                                }
                                                alt="Lock Shackle"
                                                style={getShackleStyle()}
                                            />
                                        </Box>
                                    )}


                                    {/* 🔒 LOCK BODY (CARD) */}
                                    <Box
                                        sx={{
                                            width: "350px",
                                            height: step === 2 ? '530px' : "385px",
                                            background: "#111",
                                            borderRadius: "16px",
                                            // padding: 1,
                                            boxShadow: "0px 4px 25px rgba(0,0,0,0.6)",
                                            position: "relative",
                                            overflow: "hidden",
                                            zIndex: 5,
                                        }}
                                    >
                                        {/* 🎨 Figma-style background texture overlay */}
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                inset: 0,
                                                backgroundImage: `url(${LockBodyBg})`,
                                                backgroundSize: "cover",
                                                backgroundRepeat: "no-repeat",
                                                backgroundPosition: "center",
                                                opacity: 0.10, // 10% opacity (Figma)
                                                mixBlendMode: "screen", // Blend: Screen (Figma)
                                                borderRadius: "16px",
                                                pointerEvents: "none",
                                                zIndex: 0,
                                            }}
                                        />
                                        {/* Foreground content must be above the background image */}
                                        <Box sx={{ px: 0, position: "relative", zIndex: 1 }}>
                                            {/* ---- YOUR ORIGINAL HEADER AREA (unchanged) ---- */}
                                            <Grid container alignItems="center" justifyContent="center">
                                                {(step === 1 || step === 2) && (
                                                    <Grid item xs={1} sx={{ mt: 2 }} >
                                                        <ArrowBackIcon
                                                            data-testid="arrow-back"
                                                            onClick={() => {
                                                                setStep(step - 1);
                                                                reset();
                                                            }}
                                                            sx={{ cursor: 'pointer', color: theme.themeLoginPageWhite }}
                                                        />
                                                    </Grid>
                                                )}
                                                {(step === 1 || step === 2) && (<Grid item xs={10} sx={{ mt: 2 }}>
                                                    <Typography
                                                        align="center"
                                                        sx={{
                                                            fontWeight: 600,
                                                            fontSize: "18px",
                                                            lineHeight: "27px",
                                                            color: theme.themeLoginPageWhite,
                                                            mr: 3
                                                        }}
                                                    >
                                                        {step === 2 ? "Verify With Code" : step === 1 ? "Reset Password" : ""}
                                                    </Typography>
                                                </Grid>
                                                )}
                                                <Grid item sx={{ mt: 2 }}>
                                                    <img src={originHost === 'warehouse' ? Logo : `${dynamicDomain}/logo.png`} height="28px" />
                                                </Grid>
                                                <Grid item sm={12} xs={12} sx={{ mt: 2, mb: 1 }}>
                                                    <Typography align="center" sx={{ fontWeight: 600, ...textClasses.normalText, color: "#CFCFCF" }}>
                                                        Warehouse & Inventory Management System
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                                {/* ---- YOUR EXISTING LOGIN FIELDS ---- */}

                                                <>
                                                    {/* YOUR OTP, EMAIL, PASSWORD, CONFIRM PASSWORD COMPONENTS */}
                                                    {/* 🔥 Your entire input code remains EXACTLY SAME */}
                                                    {/** ✨ Insert your full unchanged JSX here (the long form logic you provided) **/}
                                                    {step === 2 && (
                                                        <Grid
                                                            sx={{ pl: 3, pr: 3, mt: 2 }}
                                                            container
                                                            direction="row"
                                                            alignItems="center"
                                                            justifyContent="center"
                                                        >
                                                            <TextField
                                                                variant="outlined"
                                                                type="number"
                                                                placeholder="Enter Your OTP"
                                                                error={!!errors.otp}
                                                                helperText={errors.otp ? "Please enter valid OTP (must be 6 digits)" : ""}
                                                                data-testid="otp-input"
                                                                fullWidth
                                                                size="small"
                                                                InputLabelProps={{ shrink: false }}

                                                                /* 🔥 INLINE STYLE (HIGHEST PRIORITY) */
                                                                inputProps={{
                                                                    style: {
                                                                        color: theme.themeWhite,
                                                                        WebkitTextFillColor: theme.themeWhite,
                                                                        caretColor: theme.themeWhite,
                                                                    },
                                                                    inputMode: "numeric",
                                                                    pattern: "[0-9]*",
                                                                }}

                                                                sx={{
                                                                    "& .MuiOutlinedInput-root": {
                                                                        backgroundColor: "#0E0E0E99 !important",
                                                                        borderRadius: "0px !important",
                                                                        boxShadow: "none !important",

                                                                        "& fieldset": {
                                                                            border: "none !important",
                                                                        },
                                                                        "&:hover fieldset": {
                                                                            border: "none !important",
                                                                        },
                                                                        "&.Mui-focused fieldset": {
                                                                            border: "none !important",
                                                                        },
                                                                        "&.Mui-focused": {
                                                                            backgroundColor: "#0E0E0E99 !important",
                                                                        },
                                                                    },

                                                                    /* 🔥 KILL NUMBER + CHROME HEURISTICS */
                                                                    "& input": {
                                                                        WebkitAppearance: "none",
                                                                        MozAppearance: "textfield",
                                                                        appearance: "textfield",
                                                                        color: `${theme.themeWhite} !important`,
                                                                        WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                        caretColor: theme.themeWhite,
                                                                    },

                                                                    "& input:focus": {
                                                                        color: `${theme.themeWhite} !important`,
                                                                        WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                    },

                                                                    "& input:active": {
                                                                        color: `${theme.themeWhite} !important`,
                                                                        WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                    },

                                                                    /* REMOVE SPINNERS */
                                                                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                                                        WebkitAppearance: "none",
                                                                        margin: 0,
                                                                    },

                                                                    "& input[type=number]": {
                                                                        MozAppearance: "textfield",
                                                                    },

                                                                    "& .MuiInputBase-input::placeholder": {
                                                                        color: theme.themeLoginPageWhite,
                                                                        opacity: 1,
                                                                    },

                                                                    /* AUTOFILL (SAFE) */
                                                                    "& input:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                        WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                        caretColor: theme.themeWhite,
                                                                        transition: "background-color 9999s ease-out 0s",
                                                                    },
                                                                    "& input:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                    },
    
                                                                    "& input:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                    },
    
                                                                    "& input:-webkit-autofill:active": {
                                                                        WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                    },
                                                                }}

                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <LockOutlinedIcon sx={{ color: getIconColor(watch("otp")) }} />
                                                                        </InputAdornment>
                                                                    ),
                                                                }}

                                                                onKeyDown={(e) => onPressingEnterFunction(e)}
                                                                {...register("otp", { required: true, validate: valid_otp_six_digit })}
                                                            />
                                                        </Grid>

                                                    )}
                                                    <Grid
                                                        sx={{ pl: 3, pr: 3, mt: 2 }}
                                                        container
                                                        direction={'row'}
                                                        alignItems={'center'}
                                                        justifyContent={'center'}
                                                    >
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            data-testid="email-input"
                                                            type="email"
                                                            placeholder="Email / Mobile Number"
                                                            error={!!errors.email}
                                                            helperText={errors.email ? "Please enter valid email" : ""}

                                                            /* 🔥 INLINE STYLE (HIGHEST PRIORITY – DO NOT REMOVE) */
                                                            inputProps={{
                                                                style: {
                                                                    color: theme.themeWhite,
                                                                    WebkitTextFillColor: theme.themeWhite,
                                                                    caretColor: theme.themeWhite,
                                                                },
                                                            }}

                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <MailOutlineIcon sx={{ color: getIconColor(watch("email")) }} />
                                                                    </InputAdornment>
                                                                ),
                                                                notched: false
                                                            }}
                                                            InputLabelProps={{ shrink: false }}

                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    backgroundColor: "#0E0E0E99 !important",
                                                                    borderRadius: "0px !important",
                                                                    boxShadow: "none !important",

                                                                    "& fieldset": {
                                                                        border: "none !important",
                                                                    },
                                                                    "&:hover fieldset": {
                                                                        border: "none !important",
                                                                    },
                                                                    "&.Mui-focused fieldset": {
                                                                        border: "none !important",
                                                                    },
                                                                    "&.Mui-focused": {
                                                                        backgroundColor: "#0E0E0E99 !important",
                                                                    },
                                                                },

                                                                /* 🔥 KILL CHROME EMAIL HEURISTICS */
                                                                "& input": {
                                                                    WebkitAppearance: "none",
                                                                    appearance: "none",
                                                                    color: `${theme.themeWhite} !important`,
                                                                    WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                    caretColor: theme.themeWhite,
                                                                },

                                                                "& input:focus": {
                                                                    color: `${theme.themeWhite} !important`,
                                                                    WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                },

                                                                "& input:active": {
                                                                    color: `${theme.themeWhite} !important`,
                                                                    WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                },

                                                                "& .MuiInputBase-input::placeholder": {
                                                                    color: theme.themeLoginPageWhite,
                                                                    opacity: 1,
                                                                },

                                                                /* AUTOFILL */
                                                                "& input:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                    WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                    caretColor: theme.themeWhite,
                                                                    transition: "background-color 9999s ease-out 0s",
                                                                },
                                                                "& input:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                },
                                                                "& input:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                },
                                                                "& input:-webkit-autofill:active": {
                                                                    WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                },
                                                            }}

                                                            {...register("email", { required: true, validate: valid_email })}
                                                            onKeyDown={(e) => onPressingEnterFunction(e)}
                                                        />
                                                    </Grid>

                                                    {(step === 0 || step === 2) && (
                                                        <Grid
                                                            sx={{ pl: 3, pr: 3, mt: 2 }}
                                                            container
                                                            direction="column"
                                                            alignItems="center"
                                                            justifyContent="center"
                                                        >
                                                            {/* PASSWORD FIELD */}
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                fullWidth
                                                                type={showPassword ? "text" : "password"}
                                                                placeholder={step === 2 ? "Enter new password" : "Password"}
                                                                error={!!errors.password}
                                                                helperText={
                                                                    errors.password
                                                                        ? `Please enter ${step === 2 ? "new " : ""}password`
                                                                        : ""
                                                                }
                                                                data-testid="password-input"

                                                                /* 🔥 INLINE STYLE (HIGHEST PRIORITY) */
                                                                inputProps={{
                                                                    style: {
                                                                        color: theme.themeWhite,
                                                                        WebkitTextFillColor: theme.themeWhite,
                                                                        caretColor: theme.themeWhite,
                                                                    },
                                                                }}

                                                                sx={{
                                                                    "& .MuiOutlinedInput-root": {
                                                                        backgroundColor: "#0E0E0E99 !important",
                                                                        borderRadius: "0px !important",
                                                                        boxShadow: "none !important",

                                                                        "& fieldset": {
                                                                            border: "none !important",
                                                                        },
                                                                        "&:hover fieldset": {
                                                                            border: "none !important",
                                                                        },
                                                                        "&.Mui-focused fieldset": {
                                                                            border: "none !important",
                                                                        },
                                                                        "&.Mui-focused": {
                                                                            backgroundColor: "#0E0E0E99 !important",
                                                                        },
                                                                    },

                                                                    /* 🔥 KILL CHROME PASSWORD HEURISTICS */
                                                                    "& input": {
                                                                        WebkitAppearance: "none",
                                                                        appearance: "none",
                                                                        color: `${theme.themeWhite} !important`,
                                                                        WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                        caretColor: theme.themeWhite,
                                                                    },

                                                                    "& input:focus": {
                                                                        color: `${theme.themeWhite} !important`,
                                                                        WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                    },

                                                                    "& input:active": {
                                                                        color: `${theme.themeWhite} !important`,
                                                                        WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                    },

                                                                    "& .MuiInputBase-input": {
                                                                        paddingLeft: "8px",
                                                                    },

                                                                    "& .MuiInputBase-input::placeholder": {
                                                                        color: theme.themeLoginPageWhite,
                                                                        opacity: 1,
                                                                    },

                                                                    /* AUTOFILL */
                                                                    "& input:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                        WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                        caretColor: theme.themeWhite,
                                                                        transition: "background-color 9999s ease-out 0s",
                                                                    },
                                                                    "& input:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                    },
                                                                    "& input:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                    },
                                                                    "& input:-webkit-autofill:active": {
                                                                        WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                    },
                                                                }}

                                                                InputProps={{
                                                                    disableUnderline: true,
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <LockOutlinedIcon
                                                                                sx={{
                                                                                    color: getIconColor(
                                                                                        watch(step === 2 ? "newPassword" : "password")
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        </InputAdornment>
                                                                    ),
                                                                    ...(step === 2
                                                                        ? {
                                                                            endAdornment: (
                                                                                <InputAdornment position="end">
                                                                                    <IconButton
                                                                                        aria-label="toggle password visibility"
                                                                                        onClick={handleClickShowPassword}
                                                                                        onMouseDown={handleMouseDownPassword}
                                                                                        edge="end"
                                                                                        data-testid="show-password"
                                                                                        sx={{ color: theme.themeLoginPageWhite }}
                                                                                    >
                                                                                        {showPassword ? (
                                                                                            <VisibilityOff
                                                                                                sx={{
                                                                                                    color: getIconColor(
                                                                                                        watch("newPassword")
                                                                                                    ),
                                                                                                }}
                                                                                            />
                                                                                        ) : (
                                                                                            <Visibility
                                                                                                sx={{
                                                                                                    color: getIconColor(
                                                                                                        watch("newPassword")
                                                                                                    ),
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    </IconButton>
                                                                                </InputAdornment>
                                                                            ),
                                                                        }
                                                                        : {}),
                                                                }}

                                                                {...register(step === 2 ? "newPassword" : "password", { required: true })}
                                                                onKeyDown={onPressingEnterFunction}
                                                            />

                                                            {/* ERROR MESSAGE */}
                                                            {/* {errors.password && (
                                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px" }}>
                                                                        Please enter {step === 2 ? "new" : ""} password
                                                                    </Typography>
                                                                )} */}
                                                            {/* SHOW PASSWORD (step 0 only) + FORGOT PASSWORD ROW */}
                                                            <Grid
                                                                container
                                                                sx={{
                                                                width: {
                                                                    xs: "90%",
                                                                    sm: "90%",
                                                                    md: "90%",
                                                                },
                                                                mt: 1,
                                                            }}
                                                            alignItems="center"
                                                            justifyContent="space-between"
                                                        >
                                                            {step === 0 && (
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={showPassword}
                                                                            onChange={handleClickShowPassword}
                                                                            disabled={!passwordValue} // 🔥 disable when empty
                                                                            sx={{
                                                                                color: theme.themeLoginPageWhite,
                                                                                "&.Mui-checked": { color: theme.themeOrange },
                                                                                "&.Mui-disabled": {
                                                                                    color: "#555555", // optional: muted disabled color
                                                                                },

                                                                            }}
                                                                        />
                                                                    }
                                                                    label={
                                                                        <Typography
                                                                            sx={{
                                                                                color: passwordValue ? theme.themeOrange : "#555555",
                                                                                ...textClasses.normalText,
                                                                            }}
                                                                        >
                                                                            Show Password
                                                                        </Typography>
                                                                    }
                                                                />
                                                            )}
                                                            {step === 0 && (
                                                                <Typography
                                                                    sx={{
                                                                        ...textClasses.normalText,
                                                                        color:
                                                                            originHost === 'warehouse'
                                                                                ? "#797979"
                                                                                : originHost === 'demoz.tektronixit.com'
                                                                                    ? '#004846'
                                                                                    : '#84155a',
                                                                        cursor: 'pointer',
                                                                        "&:hover": {
                                                                            color: "#797979",
                                                                            textDecoration: "underline"
                                                                        }
                                                                    }}
                                                                    data-testid="forgot-password"
                                                                    onClick={() => {
                                                                        setStep(1);
                                                                        reset();
                                                                        setShowLockShackError(false);
                                                                    }}
                                                                >
                                                                    Forgot Password ?
                                                                </Typography>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                )}
                                                {step === 2 && (
                                                        <Grid
                                                            sx={{ pl: 3, pr: 3, mt: 2 }}
                                                            container
                                                            direction="row"
                                                            alignItems="center"
                                                            justifyContent="center"
                                                        >
                                                            <TextField
                                                                variant="outlined"
                                                                type={showConfirmPassword ? "text" : "password"}
                                                                placeholder="Enter Confirm Password"
                                                                error={!!errors.confirmPassword}
                                                                helperText={
                                                                    errors.confirmPassword ? "Please enter confirm password" : ""
                                                                }
                                                                data-testid="confirm-password-input"
                                                                fullWidth
                                                                size="small"
                                                                InputLabelProps={{ shrink: false }}

                                                                /* 🔥 INLINE STYLE (HIGHEST PRIORITY) */
                                                                inputProps={{
                                                                    style: {
                                                                        color: theme.themeWhite,
                                                                        WebkitTextFillColor: theme.themeWhite,
                                                                        caretColor: theme.themeWhite,
                                                                    },
                                                                }}

                                                                sx={{
                                                                    "& .MuiOutlinedInput-root": {
                                                                        backgroundColor: "#0E0E0E99 !important",
                                                                        borderRadius: "0px !important",
                                                                        boxShadow: "none !important",

                                                                        "& fieldset": {
                                                                            border: "none !important",
                                                                        },
                                                                        "&:hover fieldset": {
                                                                            border: "none !important",
                                                                        },
                                                                        "&.Mui-focused fieldset": {
                                                                            border: "none !important",
                                                                        },
                                                                        "&.Mui-focused": {
                                                                            backgroundColor: "#0E0E0E99 !important",
                                                                        },
                                                                    },

                                                                    /* 🔥 KILL CHROME PASSWORD HEURISTICS */
                                                                    "& input": {
                                                                        WebkitAppearance: "none",
                                                                        appearance: "none",
                                                                        color: `${theme.themeWhite} !important`,
                                                                        WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                        caretColor: theme.themeWhite,
                                                                    },

                                                                    "& input:focus": {
                                                                        color: `${theme.themeWhite} !important`,
                                                                        WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                    },

                                                                    "& input:active": {
                                                                        color: `${theme.themeWhite} !important`,
                                                                        WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                    },

                                                                    "& .MuiInputBase-input": {
                                                                        paddingLeft: "8px",
                                                                    },

                                                                    "& .MuiInputBase-input::placeholder": {
                                                                        color: theme.themeLoginPageWhite,
                                                                        opacity: 1,
                                                                    },

                                                                    /* AUTOFILL */
                                                                    "& input:-webkit-autofill": {
                                                                        WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                        WebkitTextFillColor: `${theme.themeWhite} !important`,
                                                                        caretColor: theme.themeWhite,
                                                                        transition: "background-color 9999s ease-out 0s",
                                                                    },
                                                                    "& input:-webkit-autofill:hover": {
                                                                        WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                    },
                                                                    "& input:-webkit-autofill:focus": {
                                                                        WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                    },
                                                                    "& input:-webkit-autofill:active": {
                                                                        WebkitBoxShadow: "0 0 0 1000px #0E0E0E99 inset !important",
                                                                    },
                                                                }}

                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <LockOutlinedIcon
                                                                                sx={{ color: getIconColor(watch("confirmPassword")) }}
                                                                            />
                                                                        </InputAdornment>
                                                                    ),
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton
                                                                                aria-label="toggle password visibility"
                                                                                onClick={handleClickShowConfirmPassword}
                                                                                onMouseDown={handleMouseDownConfirmPassword}
                                                                                edge="end"
                                                                                data-testid="show-password"
                                                                                sx={{ color: theme.themeLoginPageWhite }}
                                                                            >
                                                                                {showConfirmPassword ? (
                                                                                    <VisibilityOff
                                                                                        sx={{
                                                                                            color: getIconColor(
                                                                                                watch("confirmPassword")
                                                                                            ),
                                                                                        }}
                                                                                    />
                                                                                ) : (
                                                                                    <Visibility
                                                                                        sx={{
                                                                                            color: getIconColor(
                                                                                                watch("confirmPassword")
                                                                                            ),
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                }}

                                                                {...register("confirmPassword", { required: true })}
                                                                onKeyDown={(e) => onPressingEnterFunction(e)}
                                                            />

                                                        </Grid>
                                                    )}
                                                    <Grid container item sx={{ pl: 3, pr: 3, mt: 1, mb: 4 }} justifyContent="center">
                                                        {/* SIGN IN / SEND OTP / VERIFY OTP BUTTON */}
                                                        <Button
                                                            fullWidth
                                                            size="small"
                                                            disabled={isSubmitting} // disable while loading
                                                            data-testid={
                                                                step === 0
                                                                    ? "signin-btn"
                                                                    : step === 1
                                                                    ? "resetlink-btn"
                                                                    : "verifyotp-btn"
                                                        }
                                                        role="signInUserButton"
                                                        onClick={
                                                            isSubmitting
                                                                ? undefined
                                                                : step === 0
                                                                    ? handleSubmit(handleLogin)
                                                                    : step === 1
                                                                        ? handleSubmit(handleResetLink)
                                                                        : handleSubmit(handleOTPVerification)
                                                        }
                                                        sx={{
                                                            backgroundColor: "#0E0E0E99",
                                                            color: theme.themeOrange,
                                                            textTransform: "none",
                                                            fontSize: "18px",
                                                            fontWeight: 900,
                                                            paddingY: "3px",
                                                            borderRadius: "2px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            gap: 1,
                                                            cursor: isSubmitting ? "not-allowed" : "pointer",
                                                            "&:hover": {
                                                                backgroundColor: "#2a2a2a",
                                                            },
                                                            "&.Mui-disabled": {
                                                                backgroundColor: "#0E0E0E99",
                                                                color: theme.themeOrange,
                                                                opacity: 0.7, // optional: subtle disabled feel
                                                                cursor: "not-allowed",
                                                            },
                                                        }}
                                                    >
                                                        {step === 0 ? (
                                                            <Person2OutlinedIcon sx={{ color: theme.themeOrange }} />
                                                        ) : (
                                                            <PinOutlinedIcon sx={{ color: theme.themeOrange }} />
                                                        )}
                                                        {getButtonLabel()}
                                                    </Button>
                                                    {/* CONTACT US */}
                                                    <Grid container justifyContent="center" sx={{ mt: 2 }}>
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 1,
                                                                color: "#797979",
                                                                fontSize: "14px",
                                                                textAlign: "center",
                                                                width: "100%",
                                                                justifyContent: "center"
                                                            }}
                                                        >
                                                            <span>Don’t have an account?</span>
                                                            <Box
                                                                component="a"
                                                                href="https://www.lynkit.in/ContactUs"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                sx={{
                                                                    color: theme.themeOrange,
                                                                    fontWeight: 600,
                                                                    cursor: "pointer",
                                                                    textDecoration: "none",
                                                                    "&:hover": {
                                                                        color: theme.themeOrange,
                                                                        textDecoration: "underline"
                                                                    }
                                                                }}
                                                            >
                                                                Contact Us
                                                            </Box>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </>

                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        )}
                        {open2FaForm && (
                            <TwoFactorAuth
                                open2FaForm={open2FaForm}
                                setOpen2FaForm={setOpen2FaForm}
                                handleBackBtnClick={handleBackBtnClick}
                                getValues={getValues}
                                dispatch={dispatch}
                            />
                        )}
                    </Grid>
                </Grid>
            )}
            <ToastContainer position="bottom-center" autoClose={false} closeOnClick={false} />
        </>
    );
};

export default Login2;